import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid';

export type GridColumnWidthModel = Record<string, number>;

export const parseUrlState = (
  searchParams: URLSearchParams,
  syncStateToUrl: boolean,
): {
  page?: number;
  pageSize?: number;
  sortModel?: GridSortModel;
  filterModel?: GridFilterModel;
} | null => {
  if (!syncStateToUrl) return null;
  const pageParam = searchParams.get('page');
  const pageSizeParam = searchParams.get('pageSize');
  const page = pageParam !== null ? Number(pageParam) : undefined;
  const pageSize = pageSizeParam !== null ? Number(pageSizeParam) : undefined;
  const sortRaw = searchParams.get('sort');
  const filterRaw = searchParams.get('filters');
  let sortModel: GridSortModel = [];
  let filterModel: GridFilterModel | null = null;
  try {
    if (sortRaw) sortModel = JSON.parse(sortRaw) as GridSortModel;
  } catch {
    sortModel = [];
  }
  try {
    if (filterRaw) filterModel = JSON.parse(filterRaw) as GridFilterModel;
  } catch {
    filterModel = null;
  }
  return {
    page: Number.isFinite(page) ? page : undefined,
    pageSize: Number.isFinite(pageSize) ? pageSize : undefined,
    sortModel,
    filterModel: filterModel ?? undefined,
  };
};
